import { FundingPolicyType } from '@shared';

export const PRODUCTS = {
  'Nationwide': 'Demo Asset-Based Hybrid Policy A',
  'OneAmerica': 'Demo Asset-Based Hybrid Policy B',
  'Lincoln Financial': 'Demo Asset-Based Hybrid Policy C',
  'Securian Financial': 'Demo Asset-Based Hybrid Policy D',
};

export const PRODUCTS_BY_POLICY_TYPE: Partial<Record<FundingPolicyType, string>> = {
  [FundingPolicyType.careMattersTwo]: 'Demo Asset-Based Hybrid Policy A',
  [FundingPolicyType.jointCareMatters]: 'Demo Asset-Based Hybrid Policy A',
  [FundingPolicyType.noLapseGuaranteeLife]: 'Demo Asset-Based Hybrid Policy A',
  [FundingPolicyType.assetCare]: 'Demo Asset-Based Hybrid Policy B',
  [FundingPolicyType.jointAssetCare]: 'Demo Asset-Based Hybrid Policy B',
  [FundingPolicyType.annuityCareTwo]: 'Demo Asset-Based Hybrid Policy B',
  [FundingPolicyType.assetcareThree]: 'Demo Asset-Based Hybrid Policy B',
  [FundingPolicyType.jointAssetcareThree]: 'Demo Asset-Based Hybrid Policy B',
  [FundingPolicyType.indexedAnnuityCare]: 'Demo Asset-Based Hybrid Policy B',
  [FundingPolicyType.moneyGuardFixedAdvantage]: 'Demo Asset-Based Hybrid Policy C',
  [FundingPolicyType.secureCareThree]: 'Demo Asset-Based Hybrid Policy D',
};
